export default "__VITE_ASSET__t$ASBsnY__"